<div class="file-upload-box" *ngIf="showFileUploadBox()">
  <div class="file-info-container">
    <span class="file-info" title="{{ fileUploadState.file.name }}">
      <i class="file-upload-icon fa fa-file-image-o"></i>
      <a class="file-upload-file-name">{{ fileUploadState.file.name }}</a>
    </span>
    <div class="chat-file-upload-box-buttons">
      <span *ngIf="!fileUploadState?.mediaId">
        <i class="fa fa-spinner upload-spinner"></i>
      </span>
      <button
        *ngIf="canSendFile()"
        data-automation-id="chat-file-upload-box-send-button"
        class="btn btn-dark send-button"
        title="{{ fileUploadState.file.name }}"
        (click)="sendMedia.emit(fileUploadState.mediaId)"
      >
        <span>{{ 'genesysChatFileUploadBox.sendButton' | translate }}</span>
      </button>
      <button
        class="cancel-upload-link"
        (keydown.enter)="deleteFile.emit()"
        (click)="deleteFile.emit()"
        data-automation-id="chat-file-upload-box-cancel-button"
      >
        <a><svg-icon icon="x"></svg-icon></a>
      </button>
    </div>
  </div>
</div>

<div class="file-error-box" *ngIf="showFileUploadErrorBox()">
  <div class="file-info-container" title="{{ fileUploadState.file.name }}">
    <svg-icon class="alert-icon" icon="alert"></svg-icon>
    <span class="file-info">
      {{ fileUploadState.file.name }}
    </span>
    <button
      class="cancel-upload-link"
      (keydown.enter)="deleteFile.emit()"
      (click)="deleteFile.emit()"
      data-automation-id="chat-file-upload-box-cancel-button"
    >
      <a><svg-icon icon="x"></svg-icon></a>
    </button>
  </div>
  <div class="error-message">{{ 'genesysChatFileUploadBox.errorMessage' | translate }}</div>
</div>
